<!--  -->
<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="account_id"
        label="广告主"
        width="150"
        align="center"
      />
      <el-table-column
        prop="audience_id"
        label="人群包id"
        width="150"
        align="center"
      />
      <el-table-column
        prop="custom_audience_file_id"
        label="数据文件id"
        width="150"
        align="center"
      />
      <el-table-column
        prop="user_id_type"
        label="用户类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="user_count"
        label="文件用户数"
        width="100"
        align="center"
      />
      <el-table-column
        prop="created_at"
        label="上传时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="operation_type_text"
        label="文件操作类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.status == 1"
            style="color:green"
            class="el-icon-success"
          />
          <i
            v-if="scope.row.status == 2"
            style="color:red"
            class="el-icon-error"
          />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>

      <el-table-column
        prop="fail_reason"
        label="失败原因"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { audienceupload } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        audience_id: ''
      },
      total: null,
      tableData: [],
      loading: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(audience_id) {
      this.query.audience_id = audience_id
      this.list()
    },
    list() {
      this.loading = true
      audienceupload(this.query).then(res => {
        console.log('res', res)
        this.loading = false
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.query.page_size = data
      this.list()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.query.page = data
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
